module.exports = __webpack_public_path__ + "media/svg/loupe-e2a9b688.svg";